import React from 'react';

const NotFound = () => (
  <h1>Page not found</h1>
);

export default NotFound;
